import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-fcbc301e.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';

/**
Fallback for when we don't have logos
*/
function LogoFallback({
  componentEl: ComponentEl,
  margin,
  className,
  text,
  maxlen,
  maxlines,
  ...otherProps
}) {
  let cssClasses = ['st_logofallback'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  const words = text.split(' ');
  let finalText = [];
  let maxlenReached = false;
  words.forEach(w => {
    if (w.length > maxlen) {
      finalText = finalText.concat(w.match(new RegExp(`.{1,${maxlen}}`, 'g')));
      maxlenReached = true;
    } else {
      finalText.push(w);
    }
  });
  if (maxlines) {
    finalText = finalText.slice(0, maxlines);
  }
  if (finalText.length > 3 || maxlen > 3 && maxlenReached) {
    cssClasses.push('st_logofallback--xs');
  }
  return /*#__PURE__*/React.createElement(ComponentEl, _extends({
    "aria-label": text,
    className: cssClasses.join(' ')
  }, otherProps), finalText.map(w => /*#__PURE__*/React.createElement("span", {
    key: w
  }, w)));
}
LogoFallback.propTypes = {
  /**
   * Text to display for fallback brand */
  text: PropTypes.string.isRequired,
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** max number of characters per line */
  maxlen: PropTypes.number,
  /** max number of lines, if any */
  maxlines: PropTypes.number
};
LogoFallback.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  maxlen: 5,
  maxlines: 3
};

export { LogoFallback as L };
